module.exports = __webpack_public_path__ + "img/getac-logo.f54d8413.svg";